"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const recoil_1 = require("recoil");
const roomFilterState_1 = require("./roomFilterState");
const react_i18next_1 = require("react-i18next");
const Skeleton_1 = __importDefault(require("@mui/material/Skeleton"));
const ToggleButtonGroup_1 = __importDefault(require("@mui/material/ToggleButtonGroup"));
const ToggleButton_1 = __importDefault(require("@mui/material/ToggleButton"));
function default_1({ isUserInfoReady, isFirstVisit, hasCategory, isFetching, }) {
    const [roomTypeFilter, setRoomTypeFilter] = (0, recoil_1.useRecoilState)(roomFilterState_1.roomTypeFilterState);
    const onRoomTypeFilterChange = (_, roomType) => {
        !isFetching && roomType !== null && setRoomTypeFilter(roomType);
    };
    const { t } = (0, react_i18next_1.useTranslation)();
    const recentRoomTypeFilterText = isFirstVisit
        ? t('I-인기')
        : hasCategory
            ? t('나의 최신')
            : t('최신');
    const skeletonWidthArr = [36, 20, 36, 64, 48];
    if (!isUserInfoReady) {
        return ((0, jsx_runtime_1.jsx)("div", Object.assign({ css: { display: 'flex', flexWrap: 'wrap', gap: '10px 20px' } }, { children: skeletonWidthArr.map((width, index) => ((0, jsx_runtime_1.jsx)(Skeleton_1.default, { variant: "rectangular", animation: "wave", sx: { width: `${width}px`, height: '26px', borderRadius: '3px' } }, `rooms_type_filter_skeleton_${width}_${index}`))) })));
    }
    return ((0, jsx_runtime_1.jsxs)(ToggleButtonGroup_1.default, Object.assign({ "aria-label": "main_rooms_room_type_filter", exclusive: true, value: roomTypeFilter, onChange: onRoomTypeFilterChange, sx: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: '10px 20px',
            borderRadius: 0,
            '.MuiToggleButton-root': {
                flexShrink: 0,
                padding: 0,
                border: '0 !important',
                borderRadius: 0,
                bgcolor: 'var(--white) !important',
                color: 'rgba(0, 0, 0, 0.3)',
                fontWeight: 'bold',
            },
            '.Mui-selected': {
                color: 'rgba(0, 0, 0, 0.8) !important',
            },
        } }, { children: [(0, jsx_runtime_1.jsx)(ToggleButton_1.default, Object.assign({ "aria-label": "recent", value: "" }, { children: (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "subtitle2" }, { children: recentRoomTypeFilterText })) })), (0, jsx_runtime_1.jsx)(ToggleButton_1.default, Object.assign({ "aria-label": "like-counts", value: "pop" }, { children: (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "subtitle2" }, { children: t('I-찜') })) })), (0, jsx_runtime_1.jsx)(ToggleButton_1.default, Object.assign({ "aria-label": "view-counts", value: "view-counts" }, { children: (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "subtitle2" }, { children: t('I-조회') })) })), (0, jsx_runtime_1.jsx)(ToggleButton_1.default, Object.assign({ "aria-label": "demand-survey", value: "demand" }, { children: (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "subtitle2" }, { children: t('수요조사') })) })), (0, jsx_runtime_1.jsx)(ToggleButton_1.default, Object.assign({ "aria-label": "commission", value: "commission" }, { children: (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "subtitle2" }, { children: t('커미션') })) }))] })));
}
exports.default = default_1;
